// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Notification } from './notification';
import {
    NotificationFromJSON,
    NotificationFromJSONTyped,
    NotificationToJSON,
    NotificationToJSONTyped,
} from './notification';

/**
 * 
 * @export
 * @interface DaeNotificationsResponse
 */
export interface DaeNotificationsResponse {
    /**
     * 
     * @type {string}
     * @memberof DaeNotificationsResponse
     */
    nextToken?: string;
    /**
     * 
     * @type {Array<Notification>}
     * @memberof DaeNotificationsResponse
     */
    notifications: Array<Notification>;
}

/**
 * Check if a given object implements the DaeNotificationsResponse interface.
 */
export function instanceOfDaeNotificationsResponse(value: object): value is DaeNotificationsResponse {
    if (!('notifications' in value) || value['notifications'] === undefined) return false;
    return true;
}

export function DaeNotificationsResponseFromJSON(json: any): DaeNotificationsResponse {
    return DaeNotificationsResponseFromJSONTyped(json, false);
}

export function DaeNotificationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DaeNotificationsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'nextToken': json['nextToken'] == null ? undefined : json['nextToken'],
        'notifications': ((json['notifications'] as Array<any>).map(NotificationFromJSON)),
    };
}

export function DaeNotificationsResponseToJSON(json: any): DaeNotificationsResponse {
    return DaeNotificationsResponseToJSONTyped(json, false);
}

export function DaeNotificationsResponseToJSONTyped(value?: DaeNotificationsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nextToken': value['nextToken'],
        'notifications': ((value['notifications'] as Array<any>).map(NotificationToJSON)),
    };
}
